﻿'use strict';

(function () {
    setInterval(hCaptchaChangeDetectorCallback, 1000);
})();

function initializeHCaptcha(sitekey: string) {
    $('#hCaptchaWrapper').append(`<div class="h-captcha" data-sitekey="${sitekey}"></div>`);

    // Load the SDK after its container exists, including when page scripts are deferred.
    if (typeof document !== 'undefined' && !document.querySelector('script[data-hcaptcha-sdk]')) {
        const script = document.createElement('script');
        script.src = 'https://js.hcaptcha.com/1/api.js';
        script.async = true;
        script.dataset.hcaptchaSdk = '';
        document.head.appendChild(script);
    }
}

function hCaptchaChangeDetectorCallback() {
    const hCaptchaValue = $('[name=h-captcha-response]').val();

    if (
        $('#submitButton').attr('aria-busy') === 'true' ||
        typeof hCaptchaValue !== 'string' ||
        hCaptchaValue.trim() === ''
    ) {
        $('#submitButton').prop('disabled', true);
    } else {
        $('#submitButton').prop('disabled', false);
    }
}

Object.assign(globalThis, { initializeHCaptcha, hCaptchaChangeDetectorCallback });

if (typeof document !== 'undefined') {
    const initialize = () => {
        const key = document.getElementById('hCaptchaWrapper')?.dataset.sitekey;

        if (key) {
            initializeHCaptcha(key);
        }
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initialize, { once: true });
    } else {
        initialize();
    }
}
